export default __webpack_public_path__ + "static/media/environment.a9d69084.png";